import $ from 'jquery';

var armed = true;
var oldPos = null;

function GalleryFancyBoxInit() {
  var selector = '.fancybox-gallery';
  $(selector).fancybox({
    padding: 5,
    margin: 5,
    prevEffect: 'fade',
    nextEffect: 'fade',
    helpers: {
      title: {
        type: 'inside'
      },
      thumbs: {
        width: 125,
        height: 75,
      }
    }
  });
}

function GalleryFancyVideoInit() {
  var selector = '.fancybox-video-gallery';
  $(selector).fancybox({
    maxWidth: 800,
    maxHeight: 450,
    fitToView: false,
    width: '70%',
    height: '70%',
    autoSize: false,
    closeClick: false,
    openEffect: 'none',
    closeEffect: 'none',
    padding: 5,
    margin: 5,
    prevEffect: 'none',
    nextEffect: 'none',
    helpers: {
      title: {
        type: 'inside'
      },
      thumbs: {
        width: 125,
        height: 75,
      }
    }
  });
}

function GalleryScrollDownInit() {
  var container = '#gallery-folders';
  var tolerance = parseInt($(document).height() * 0.05);  // 5% tolerance for document scroll bottom measure
  if ($(container).length) {
    var url = $(container).attr("data-url");
    $(window).scroll(function () {
      if (($(this).scrollTop() + $(this).height() + tolerance) >= $(document).height() && armed) {
        armed = false;
        $.ajax({
          type: "POST",
          url: url + '/' + new Date().getTime(),
          data: {},
          crossDomain: true,
          headers: {'X-Requested-With':'XMLHttpRequest'},
          success: function (ret) {
            $(container).append(ret);
            armed = true;
          }
        });
      }
    });
  }
}

function GalleryItemsScrollDownInit() {
  var container = '#gallery-folder-items';
  var tolerance = parseInt($(document).height() * 0.05);  // 5% tolerance for document scroll bottom measure
  if ($(container).length) {
    $(window).scroll(function () {
      if (($(this).scrollTop() + $(this).height() + tolerance) >= $(document).height()) {
        var step = 0;
        $(container + ' .hidden').each(function () {
          $(this).removeClass("hidden");
          step++;
          if (step == 6) {
            return false;
          }
        });
      }
    });
  }
}

function GalleryFilterHandle() {
  var dateField = '#gallery-date';
  var sportField = '#gallery-sport';
  var typeField = '#gallery-type';
  var date = $(dateField).val();
  var sport = $(sportField).val();
  var type = $(typeField).val();
  if (date && sport) {
    var url = '/' + type + '-galeriak/' + sport + '-sportag' + '/idoszak-' + date + '';
  } else if (date) {
    var url = '/' + type + '-galeriak/idoszak-' + date + '';
  } else if (sport) {
    var url = '/' + type + '-galeriak/' + sport + '-sportag';
  } else {
    var url = '/' + type + '-galeriak';
  }
  location.href = url;
}

function GalleryFilterInit() {
  var sportSelector = '.gallery-sport-selector';
  var dateField = '#gallery-date';
  var sportField = '#gallery-sport';
  $(document).on('click', sportSelector, function () {
    $(sportField).val($(this).attr("data-val") + "-" + $(this).attr("data-str"));
    GalleryFilterHandle();
  });
  $(document).on('change', dateField, function () {
    GalleryFilterHandle();
  });
}

$(document).ready(function () {
  console.log("frontend: gallery ready");
  GalleryFancyBoxInit();
  GalleryFancyVideoInit();
  GalleryScrollDownInit();
  GalleryItemsScrollDownInit();
  GalleryFilterInit();
});
